export default "__VITE_ASSET__COOaOV7I__"